import React from "react";
import {
    iconLink,
    iconHtml,
    iconPdf,
    iconCompress,
    iconWord,
    iconText,
    iconExcel,
    iconPowerPoint,
    iconImagem
} from "../../../../assets/tipoDeConteudos";

const ICONS = {
    LINK: iconLink,
    EDITOR: iconHtml,
    pdf: iconPdf,
    zip: iconCompress,
    rar: iconCompress,
    "7z": iconCompress,
    docx: iconWord,
    doc: iconWord,
    odf: iconWord,
    txt: iconText,
    rtf: iconText,
    xlsx: iconExcel,
    xls: iconExcel,
    csv: iconExcel,
    ods: iconExcel,
    pptx: iconPowerPoint,
    ppt: iconPowerPoint,
    odp: iconPowerPoint
};

export const montarIcon = documento => {
    const tipo = !documento.link && !documento.editor ? documento.extensao : documento.link ? "LINK" : "EDITOR";
    
    const iconName = ICONS[tipo] || iconImagem;

    return (
        <div className="start icon-tipo-ficheiro" title={tipo}>
            <img src={iconName} style={{ height: 30, width: "100%", objectFit: "contain", borderRadius: "50%" }} />
        </div>
    );
};
